import { render } from "./AnnotationTargetCard.vue?vue&type=template&id=1a6f4ac2&ts=true"
import script from "./AnnotationTargetCard.vue?vue&type=script&lang=ts"
export * from "./AnnotationTargetCard.vue?vue&type=script&lang=ts"

import "./AnnotationTargetCard.vue?vue&type=style&index=0&id=1a6f4ac2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__